import React, { useEffect, useState } from "react";
import * as yup from "yup";
import ApiProvider from "../../../apiProvider";
import { useMsal } from "@azure/msal-react";
import Spinner from "../../skills-experience/shared/spinner";
import { CdsFormModal, CdsInputField } from "clayco-component-library";

const LicensePlateModal = ({ show, onCloseModal, plate }) => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [licensePlateNumber, setLicensePlateNumber] = useState(plate);
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);

    const plateSchema = yup.object().shape({
        plateNumber: yup.string().max(10, 'Cannot have more than ten characters'),
    });

    useEffect(() => {
        if (!show) {
            onCloseModal();
            setShowError(false);
        }
    }, [show]);

    function handleError(data) {
        console.log(data);
    }

    const savePlate = async (formData) => {
        setDisableSubmitButton(true);
        setLoading(true);
        if(plate?.id)
            await apiProvider.Post("LicensePlate/Update", {...formData, id: plate.id})
        else
            await apiProvider.Post("LicensePlate", formData)

        setLoading(false);
        onCloseModal();
    };

    return (
        <>
            <CdsFormModal
                buttonText="Save"
                buttonActionText="Saving"
                schema={plateSchema}
                onSubmit={savePlate}
                showButton={true}
                onError={handleError}
                title="Add/Modify License Plate"
                show={show}
                handleCloseClick={onCloseModal}
                disablePrimaryButton={disableSubmitButton}
            >
                {showError && (
                    <div className="alert alert-danger mb-2" role="alert">
                        Uh oh! We were unable to save your changes. Please try
                        again later.
                    </div>
                )}
                { loading ? 
                <Spinner show={loading} /> 
                : 
                <div className="m-4">
                    <CdsInputField
                        label="Plate Number"
                        required={true}
                        showTooltip={false}
                        name="plateNumber"
                        type="text"
                        placeholder=""
                        initialValue={plate?.plateNumber}
                    />
                </div>
                }
            </CdsFormModal>
        </>
    );
};

export default LicensePlateModal;
